import { render, staticRenderFns } from "./MarketingContact.vue?vue&type=template&id=d5acd918&scoped=true&"
import script from "./MarketingContact.vue?vue&type=script&lang=js&"
export * from "./MarketingContact.vue?vue&type=script&lang=js&"
import style0 from "./MarketingContact.vue?vue&type=style&index=0&id=d5acd918&lang=scss&scoped=true&"
import style1 from "./MarketingContact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5acd918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5acd918')) {
      api.createRecord('d5acd918', component.options)
    } else {
      api.reload('d5acd918', component.options)
    }
    module.hot.accept("./MarketingContact.vue?vue&type=template&id=d5acd918&scoped=true&", function () {
      api.rerender('d5acd918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/MarketingContact.vue"
export default component.exports